/* eslint-disable radix */
/* eslint-disable */
import React from 'react'
import classNames from 'classnames'
import ContentHeader from '../../containers/ContentHeader'
import Loading from '../../components/Loading'
import FormattedDate from '../../components/FormattedDate'
import EcgLoader from '../../containers/EcgLoader'
import StackControls from './components/StackControls'
import QtValuesForm from './components/QtValuesForm'
import CompareEKG from './components/CompareEKG'
import NotesAndHistoryPane from './components/NotesAndHistoryPane'
import PatientInfo from '../../components/PatientInfo'
import AddInterpretationPane from './components/AddInterpretationPane'
import PrevIcon from 'static/images/icons/chevron-left.svg'
import NextIcon from 'static/images/icons/chevron-right.svg'
import SixLeadIcon from 'static/images/six_lead_badge.svg'
import AddInterpretationControls from './components/AddInterpretationControls'
import MedantaAdhocInterpretation from '../../personalisedPrerequisite/Medanta/components/MedantaAdhocInterpretation'
import IDTFRecordingReviewPane from '../../../views/containers/IDTFRecordingReviewPane'
import classes from '../../components/Interpretation/Interpretation.css'
import {
  checkQtFeatureEnabled,
  checkServiceProviderFeatureEnabled,
  checkServiceProviderErrorFeatureEnabled,
  checkMedantaAPIFeatureEnabled,
  getMedantaConfigs,
  checkServiceInterpretationFeatureEnabled,
  checkKpAutoEk12FeatureEnabled,
  checkIdtfFeatureEnabled,
  isQtDisplayFeatureEnabled
} from 'configs'
import {
  HEADER_HEIGHT,
  SCROLLBAR_WIDTH,
  RIGHT_SIDEBAR_WIDTH,
  isEkgRecordingConfirmed,
  ekgRecordingHasInterpretations,
  TRIAGE,
  TRIAGE_OPTION,
  BOTTOM_PADDING,
  CONFIRMED,
  TABLE_BULK_ACTIONS,
  QT_SETTINGS
} from '../../constants'
import { DROPOVER_TYPES } from '../../containers/EkgRecordingReviewScreen/module'
import { calcRowSeconds, getPhysicianName } from '../../containers/Utilities'
import EkgRecording from '../../containers/EkgRecording'
import styles from './EkgRecordingReviewScreen.css'
import * as Lib from '../../constants/RecordingConstants'
import { closeModal, needToBustCache, openModal } from '../../store/appReducer'
import { EKG_RECORDING_REDUCERS } from 'state/reducers/ekgRecordings/ekgRecordingReducers'
import { EKG_QT_STATUS, EKG_QT_ERROR } from 'state/reducers/ekgRecordings/constants'
import PageUpdated from 'legacy/components/PageUpdated'
import Modal from 'legacy/containers/Modal'
import Important from 'static/images/important.svg'
import {
  truncate as mrnTruncate,
} from '../../components/PatientInfoUtils'
import modalStyles from 'legacy/containers/Modal/Modal.css'
import { getAutoEK12QTStatus } from './Util'
import Interpretation from '../../components/Interpretation'
import { shouldGeneralizeOverreadProviderInfo, shouldHideOverreadProviderInfo } from '../../../configs'

const PROFILE_INFO_HEADER_HEIGHT = 192

/*
  Calling component will pass recordingId prop. This component will take that recordingId
  and store it in selectedRecordingId and use selectedRecordingId everywhere else. recordingId
  should not be used anywhere other than updating selectedRecordingId when necessary
*/
class EkgRecordingReviewScreen extends React.PureComponent {
  state = {
    innerHeight: 0,
    // innerWidth: 0,
    qtErrorNoteShow: false,
    showErrorColor: false,
    showError: false,
  }

  UNSAFE_componentWillMount() {
    const {
      selectedRecordingId,
      recordingId,
      dataLastUpdated,
      setInitialEkgRecordingReviewScreenData,
      getEkgRecordingReviewScreenData,
    } = this.props

    if (recordingId !== selectedRecordingId) {
      setInitialEkgRecordingReviewScreenData(recordingId)
      getEkgRecordingReviewScreenData(needToBustCache(dataLastUpdated))
    }

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.recordingId !== prevProps.recordingId) {
      this.props.setInitialEkgRecordingReviewScreenData(this.props.recordingId)
      this.props.getEkgRecordingReviewScreenData()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    this.props.reset()
  }

  compareToPreviousEkg = React.createRef()

  handleResize = e => {
    this.setState({
      innerHeight: e.target.innerHeight,
      // innerWidth: e.target.innerWidth,
    })
  }

  render() {
    const {
      // from redux
      dataIsFetching,
      dataLastUpdated,
      handleOnRefreshClick,
      refreshClicked,
      ecgExporting,
      addInterpretationSubmitting,
      getEkgRecordingReviewScreenData,
      sidebarIsCollapsed,
      authorizationType,
      selectedDropover,
      invertRecording,
      toggleRecordingInvert,
      isAddInterpretationScreenVisible,
      isInterpretationHistoryExpanded,
      toggleInterpretationHistoryExpanded,
      showAddInterpretationScreen,
      cancelAddInterpretations,
      saveAddInterpretations,
      handleOnPopoverButtonClick,
      handleOnPopoverOutsideClick,
      handleOnStackControlsCancelDialogClick,
      handleOnStackControlsSuccessDialogClick,
      handleOnPatientClick,
      handleOnExportClick,
      handleStackControl,
      handleOnStackNavigationClick,
      updateInterpretations,
      updateInterpretationNotes,
      selectedInterpretations,
      showStackRemovalControl,
      selectedRecordingId,
      me,
      patient: patientDataSource,
      patients,
      physicians,
      ekg,
      ekgRelated,
      ekgSamples,
      ekgs,
      interpretations,
      singleEkgPdf,
      handleQtFormSubmit,
      // from calling component
      currentInboxId,
      recordingIds,
      updateReassignInboxId,
      reassignedInboxId,
      removeFromStackCallback,
      confirmAndArchiveCallback,
      reassignCallback,

      qtFormData,
      qtFormValidationSyncError,

      // medaanta action
      updateMedantaInterpretations,
      clearMedantaInterpretations,
      selectedMedantaInterpretations,
      vendorInterpretation,
      medantaInterpretationForm,
      templateList,
      match,
      handleQTModalClose,
      handleQTModalOpen,
      handleOnRequestQT,
    } = this.props
    const isQTEnabled = checkQtFeatureEnabled(me)
    const qtAnalysis = this.props[EKG_RECORDING_REDUCERS.EKG_QT]
    // qtAnalysis status
    const qtAnalysisStatus = this.props[EKG_RECORDING_REDUCERS.EKG_QT].status
    const qtAnalysisAlgorithmDetermination = this.props[EKG_RECORDING_REDUCERS.EKG_QT].algorithmDetermination
    const qtPostRequest = this.props[EKG_RECORDING_REDUCERS.POST_QT_REQUEST]
    const qtPostValues = this.props[EKG_RECORDING_REDUCERS.POST_QT_VALUES]
    const isMedantaAPIEnabled = checkMedantaAPIFeatureEnabled(me)
    const medantaConfig = isMedantaAPIEnabled && getMedantaConfigs(me)
    const isIDTFFeatureEnabled = checkIdtfFeatureEnabled(me)
    const isHideOverreadProviderInfoEnabled = shouldHideOverreadProviderInfo(me)
    const isGeneralizeOverreadProviderInfoEnabled = shouldGeneralizeOverreadProviderInfo(me)
    const {
      // innerWidth,
      innerHeight,
      qtErrorNoteShow,
      showErrorColor,
      showError,
    } = this.state

    const contentHeight = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING + 34
    const contentWidth = 1180
    const mainContentWidth = contentWidth - RIGHT_SIDEBAR_WIDTH

    const MIN_SECONDS = 1
    const calpulse = true
    const rowSeconds = calcRowSeconds(mainContentWidth) > 0 ? calcRowSeconds(mainContentWidth) : MIN_SECONDS
    const ekgWidth = (rowSeconds * Lib.PX_PER_SECOND) + SCROLLBAR_WIDTH
    let ekgHeight = contentHeight - PROFILE_INFO_HEADER_HEIGHT
    const extraWidth = mainContentWidth - ekgWidth

    let recording = null
    let relatedRecording = null
    let patient = null
    let physicianName = ''
    let screeningConfig= null

    const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(me)
    const isServiceProviderErrorFeatureEnabled = checkServiceProviderErrorFeatureEnabled(me)
    const isServiceInterpretationFeatureEnabled = checkServiceInterpretationFeatureEnabled(me)
    // get the feature - AutoEK-12 state from team's feature
    const isKpAutoEk12FeatureEnabled = checkKpAutoEk12FeatureEnabled(me)
    const isEkgAnalyzed = qtAnalysisStatus === 'complete'

    let latestQTAnalysis = null

    if (isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled && qtAnalysis && qtAnalysis.qt) {
      latestQTAnalysis = qtAnalysis.qt.length ? qtAnalysis.qt[qtAnalysis.qt.length - 1] : qtAnalysis.qt
    } else if (qtAnalysis && qtAnalysis.qt) {
      latestQTAnalysis = qtAnalysis.qt[qtAnalysis.qt.length - 1]
    }

    if (selectedRecordingId
      && ekgs.data && ekgs.data.byId[selectedRecordingId]
      && ekg.data && ekg.data.id === selectedRecordingId
      && ekgSamples.data && ekgSamples.data.id === selectedRecordingId
    ) {
      // recording ID exists, recording data is available for id, and has full ekg sample data
      recording = ekgs.data.byId[selectedRecordingId]

      if (ekgRelated.data && ekgRelated.data.id === selectedRecordingId && recording.relatedRecordings.length > 0) {
        relatedRecording = ekgs.data.byId[recording.relatedRecordings[0].recordingId]
      }
    }

    if (patients.data && recording && patients.data.byId[recording.participantID]) {
      patient = patients.data.byId[recording.participantID]
    }

    if (isServiceProviderEnabled && recording) {
      patient = recording.participantProfile
    }

    if (me.data) {
      physicianName = getPhysicianName(me.data.profile.firstName, me.data.profile.lastName, '');
      screeningConfig = me.data.teams[0] && me.data.teams[0].screeningConfig;
    }

    let reassignedInbox
    let inboxOptions = [
      TRIAGE_OPTION,
    ]
    switch (reassignedInboxId) {
      case TRIAGE:
        reassignedInbox = TRIAGE_OPTION
        break
      default:
        if (physicians.data) {
          reassignedInbox = reassignedInboxId && physicians.data.byId[reassignedInboxId]
        }
        break
    }

    if (physicians.data) {
      inboxOptions = [...inboxOptions, ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id])]
    }

    let currentEcgIndex = 1
    let totalEcgCount = 1
    let hasStackNavigationControls = false

    if (recordingIds) {
      hasStackNavigationControls = currentInboxId !== CONFIRMED
      currentEcgIndex = (recordingIds.indexOf(selectedRecordingId)) + 1
      if (currentEcgIndex === 0) {
        // setting to false b/c the recordId is not in the first set of recordingIds
        // It's probably deleted or in the next set of recordingIds
        hasStackNavigationControls = false
      }
      totalEcgCount = recordingIds.length
    }

    let disableQTAction = !isQTEnabled
    if (isQTEnabled && recording) {
      disableQTAction = qtPostRequest.isFetching || (qtAnalysisStatus !== null && qtAnalysisStatus !== 'not_started')
    }

    const getQtAnalysisStatus = () => {
      // get the Initial QT status from data
      let status = qtAnalysisStatus && (EKG_QT_STATUS[qtAnalysisStatus.toUpperCase()])

      // check if status has to cross-check with ek-12
      if (isKpAutoEk12FeatureEnabled) {
        let autoEK12Status = getAutoEK12QTStatus(qtAnalysisAlgorithmDetermination, qtAnalysisStatus, latestQTAnalysis)
        status = autoEK12Status.status
        // check for error / text representation 
        if (autoEK12Status.showErrorColor && !autoEK12Status.showError ) {
          this.setState({
            showErrorColor: true,
            showError: false
          })
        } else if (autoEK12Status.showError && !autoEK12Status.showErrorColor) {
          this.setState({
            showError: true,
            showErrorColor: false
          }) 
        }
        else if (!autoEK12Status.showError && !autoEK12Status.showErrorColor){
          this.setState({
            showError: false,
            showErrorColor: false
          })
        }
      } else if (qtAnalysis && qtAnalysis.qt && qtAnalysis.qt.errorType) {
        status = `${status} with Error: ${EKG_QT_ERROR[qtAnalysis.qt.errorType.toUpperCase()]}`
      }
      return status
    }

    // save button disable and enable control in interpretatio
    const isSaveDisabledCheck = (selectedInterpretation, serviceProviderEnabled, qtData) => {
      if (serviceProviderEnabled) {
        if ((typeof qtData !== 'undefined') || selectedInterpretation.length !== 0) {
          if (Object.keys(qtFormValidationSyncError).length !== 0) {
            return true
          }
          return false
        }
        return true
      } else {
        if (selectedInterpretation.length === 0) {
          return true
        }
        return false
      }
    }

    const checkConfirmButton = recordingCheck => {
      const qtLengthCheck = qtAnalysis && qtAnalysis.qt && qtAnalysis.qt.length
      if (isServiceProviderEnabled) {
        return (!ekgRecordingHasInterpretations(recordingCheck) && !qtLengthCheck > 0)
      }
      return !ekgRecordingHasInterpretations(recordingCheck)
    }
    const getErrorNote = note => {
      if (note.length > 80) {
        const shortNote = note && note.slice(0, 80)
        return qtErrorNoteShow ? (
          <span className={styles.qtErrorNoteShow}>
            {note} <a onClick={() => this.setState({ qtErrorNoteShow: false })}>Read Less</a>
          </span>
        ) : (
          <span className={styles.qtErrorNote}>
            {shortNote}... <a onClick={() => this.setState({ qtErrorNoteShow: true })}>Read More</a>
          </span>
        )
      } else {
        return note
      }
    }
    if (qtAnalysis && qtAnalysis.qt && qtAnalysis.qt.error) {
      // 32 is the height of the error note
      ekgHeight -= 32
    }

    // Based on ek12 feature in practice alter the text of button.
    const qtButtonText = isKpAutoEk12FeatureEnabled ? 'Request ECG Analysis' : 'Request QT Analysis'
    const qtConfirmText = isKpAutoEk12FeatureEnabled ? ' Are you sure you want to request ECG Analysis?' : ' Are you sure you want to request QT Analysis?'


    /**
     * Generates overread provider info
     * 1. use 'Algorithmic Result' if the calculationType is automatic
     * 2. if calculationType is manual 
     * uses generic terminology if the customer does not wants to display
     * (if "generalize-overread-provider-info" features is enabled in KPA)
     * otherwise displays overread provide name and team name if available.
     *  
     * @param {Object} qtAnalysis 
     * @param {Boolean} useGenericTerminology 
     * @returns 
     */
    const generateOverreadProviderInfo = (qtAnalysis, useGenericTerminology) => {
      const {
        memberFirstName,
        memberLastName,
        createdAt,
        teamName,
        qt = '',
        qtcb = '',
        qtcf = '',
        rr = '',
        calculationType,
      } = qtAnalysis;
      const algorithmicResultTerm = 'Algorithmic Result: '
      const overreadProviderGenericTerm = 'Cardiac Specialist Reviewed: '
      const overreadProviderNameAndTeamName = (memberFirstName && memberLastName && teamName) ? `Reviewed by ${memberFirstName} ${memberLastName} from ${teamName} ` : ''

      let overreadProviderName = '';
      if (calculationType === 'automatic') {
        overreadProviderName = algorithmicResultTerm;
      } else if (calculationType === 'manual') {
         overreadProviderName = useGenericTerminology ? overreadProviderGenericTerm : overreadProviderNameAndTeamName
      }
      const teamDetailsTextLine1 = (
        <p>
           { overreadProviderName }
        </p>
      );
      const teamDetailsTextLine2 = <FormattedDate date={createdAt} me={me} />;
      const teamDetailsTextLine3 = (
        <p>
          QT: {qt && Math.round(qt)}, QTcf: {qtcf && Math.round(qtcf)}, QTcb: {qtcb && Math.round(qtcb)}, RR: {rr && Math.round(rr)}
        </p>
      );
      const teamDetailsText = (
        <div className={`${classes.interpretation} ${classes.ekgNoAnalysis}`}>
          {teamDetailsTextLine1}
          {teamDetailsTextLine2}
          {(isServiceProviderEnabled || isQTEnabled) &&
            qtAnalysis &&
            teamDetailsTextLine3}
        </div>
      );
      return teamDetailsText;
    };

    return (
      <div
        className={styles.ekgRecordingReviewScreen}
      >
        <ContentHeader
          showAddPatient={false}
          enableBackButton={true}
          showLastRefresh={false}
          text="ECG Recording"
          className={styles.pageContentHeader}
          me={me}
        />
        <div
          className={styles.headerControls}
          style={{
            width: contentWidth - 290,
            marginLeft: 290,
          }}
        >
          <div>{' '}
            {hasStackNavigationControls &&
              <div
                className={styles.ecgSelection}
              >
                <button
                  className={styles.prevButton}
                  onClick={() => handleOnStackNavigationClick(-1, currentInboxId, selectedRecordingId, recordingIds)}
                  disabled={currentEcgIndex === 1 || dataIsFetching || refreshClicked}
                >
                  <PrevIcon />
                </button>
                <p className={styles.ecgText}>{currentEcgIndex}<span>of</span>{totalEcgCount}</p>
                <button
                  className={styles.nextButton}
                  onClick={() => handleOnStackNavigationClick(1, currentInboxId, selectedRecordingId, recordingIds)}
                  disabled={currentEcgIndex === totalEcgCount || dataIsFetching || refreshClicked}
                >
                  <NextIcon />
                </button>
              </div>
            }
          </div>
          <div className={styles.headerControlsRefresh}>
            <PageUpdated
              className={styles.refreshContainer}
              isLoading={dataIsFetching}
              lastUpdated={dataLastUpdated}
              handleOnClick={handleOnRefreshClick}
              hasTabs={false}
              me={me}
            />
          </div>
        </div>
        {!dataIsFetching || addInterpretationSubmitting || ecgExporting
          ? (
            <div className={styles.content}>
              <div
                className={styles.main}
                style={{
                  minWidth: `${mainContentWidth - extraWidth}px`,
                  height: contentHeight,
                }}
              >
                {recording === null ? (
                  <div className={styles.recordingNotFound}>
                    <p>The recording was not found.</p>
                  </div>
                ) : (
                  <div>
                    <div className={styles.profile}>
                      {patient &&
                        <div className={styles.profileWrapper}>
                          <div className={styles.name}>
                            <p>
                              {!isServiceProviderEnabled ? (
                                <span>{patient.firstName} {patient.lastName}</span>
                              ) : (
                                <span>{mrnTruncate(patient.customParticipantID)}</span>
                              )
                              }
                            </p>
                            <div className={styles.controls}>
                              <button
                                className={styles.exportButton}
                                onClick={() => (!ecgExporting ? handleOnExportClick() : undefined)}
                                disabled={ecgExporting}
                                data-category="ekg-review-ekg-recording"
                                data-action="download-ecg"
                              >
                                Download ECG
                              </button>
                              {!isServiceProviderEnabled && showStackRemovalControl && patient &&
                                <button
                                  className={styles.viewPatientButton}
                                  onClick={() => handleOnPatientClick(true, true, { patientId: patient.id, referral: 'ekgInbox' })}
                                  data-category="ekg-review-ekg-recording"
                                  data-action="view-patient-file"
                                >
                                  View Patient File
                                </button>
                              }
                            </div>
                          </div>
                          <PatientInfo
                            participant={patient}
                            ecgView={true}
                            showAllDetails={!isServiceProviderEnabled}
                            orderingPractice={recording.orderingPractice}
                            me={me}
                          />
                        </div>
                      }
                    </div>
                    <div className={styles.ekgMetaInfo}>
                      <div className={styles.ekgDetails}>
                        <h4>ECG Details</h4>
                        <div>
                          <span className={styles.ekgDetailsLabel}>Heart Rate:</span>
                          {!ekgSamples.isFetching && recording && `${recording.bpm} BPM`}
                        </div>
                        <div>
                          <span className={styles.ekgDetailsLabel}>Recorded:</span>
                          {!ekgSamples.isFetching && recording && (
                            <FormattedDate date={recording.recordedAt} me={me} />
                          )}
                          {!ekgSamples.isFetching && recording && recording.is6l &&
                            <React.Fragment>
                              <span className={styles.divider} />
                              <SixLeadIcon className={styles.sixLIcon} />
                            </React.Fragment>
                          }
                        </div>
                      </div>
                      {((recording && recording.is6l && isQTEnabled) || (isServiceProviderEnabled && qtAnalysis && qtAnalysis.qt && latestQTAnalysis) || (isKpAutoEk12FeatureEnabled && qtAnalysis)) ? (
                        <div className={styles.ekgQTDetails}>
                          {qtPostRequest.error && (
                            <div className={styles.qtError}>
                              <p className={styles.errorTitle}>
                                <Important />
                                <span>Error({qtPostRequest.error.status}): {qtPostRequest.error.title}</span>
                              </p>
                              <p className={styles.errorDetail}>{qtPostRequest.error.detail}</p>
                            </div>
                          )}
                          <div className={styles.ekgQTDetailsRow}>
                            <h4 className={styles.ekgQTStatus}>
                              <span className={styles.qtStatusLabel}>QT Analysis: </span>
                              {/* showErrorColor state is for the red color text */}
                              <span className={!showErrorColor ? styles.qtStatus : styles.qtColorChange}>
                                {!qtPostRequest.error && getQtAnalysisStatus()}
                              </span>
                            </h4>
                            {isQTEnabled && qtAnalysisStatus !== 'complete' && recording.stackID !== CONFIRMED && (
                              <div className={styles.ekgQTAction}>
                                <div>
                                  <button
                                    onClick={handleQTModalOpen || noop}
                                    className={styles.QTButton}
                                    disabled={disableQTAction}
                                  >
                                    {qtPostRequest.isFetching ? (
                                      <div className={styles.QTButtonLoading}>
                                        <Loading size="xsmall" />
                                      </div>
                                    ) : (`${qtButtonText}`)}
                                  </button>
                                  <Modal
                                    onClose={handleQTModalClose}
                                  >
                                    <div className={modalStyles.header}>
                                      {qtConfirmText}
                                    </div>
                                    <div className={modalStyles.body}>
                                      <dl>
                                        <dt>MRN:</dt>
                                        <dd>{mrnTruncate(patient.customParticipantID)}</dd>
                                        <dt>Patient Name:</dt>
                                        <dd>{patient.firstName} {patient.lastName}</dd>
                                        <dt>Recorded</dt>
                                        <dd>
                                          {!ekgSamples.isFetching && recording && (
                                            <FormattedDate date={recording.recordedAt} me={me} />
                                          )}
                                        </dd>
                                      </dl>
                                    </div>
                                    <div className={modalStyles.controls}>
                                      <button className={modalStyles.secondaryButton} onClick={handleQTModalClose}>Cancel</button>
                                      <button className={modalStyles.primaryButton} onClick={handleOnRequestQT}>Submit</button>
                                    </div>
                                  </Modal>
                                </div>
                              </div>
                            )}
                          </div>
                          {
                            (showErrorColor || showError) &&
                            (
                              <React.Fragment>
                                <div className={styles.ekgQTDetailsRow}>
                                  <div className={classNames(styles.ekgQTDetailsCol, styles.ekgQTDetailsCol1)}>
                                    <div>
                                      <span className={styles.ekgDetailsLabel}>QT:</span>
                                      {'***'}
                                    </div>
                                    <div>
                                      <span className={styles.ekgDetailsLabel}>RR:</span>
                                      {'***'}
                                    </div>
                                  </div>
                                  <div className={classNames(styles.ekgQTDetailsCol, styles.ekgQTDetailsCol2)}>
                                    <div>
                                      <span className={styles.ekgDetailsLabel}>QTcf:</span>
                                      {'***'}
                                    </div>
                                    <div>
                                      <span className={styles.ekgDetailsLabel}>QTcb:</span>
                                      {'***'}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            )
                          }
                          {((isQTEnabled && qtAnalysis && qtAnalysis.qt && latestQTAnalysis) || (isServiceProviderEnabled && qtAnalysis && qtAnalysis.qt && latestQTAnalysis) || (isKpAutoEk12FeatureEnabled && qtAnalysis && qtAnalysis.qt && latestQTAnalysis)) &&
                            <React.Fragment>
                              {/* showErrorColor and showError state are set based on the algo value from the api */}
                              {!showErrorColor && !showError &&
                                <div className={styles.ekgQTDetailsRow}>
                                  <div className={classNames(styles.ekgQTDetailsCol, styles.ekgQTDetailsCol1)}>
                                    {/* the Service provider is supposed to see all the values. and only the 
                                      ordering physician is supposed to see the QT values masked based on the settings in KPA 
                                      ServiceProvider = qt-service-provider
                                      */}
                                    {
                                      (isServiceProviderEnabled || isQtDisplayFeatureEnabled(me, QT_SETTINGS.QT_DISPLAY_QT)) && (
                                        <div>
                                          <span className={styles.ekgDetailsLabel}>QT:</span>    
                                          {latestQTAnalysis.qt || latestQTAnalysis.qt === 0 ? Math.round(latestQTAnalysis.qt) : '***'}
                                        </div>
                                      )
                                    }
                                    {
                                      (isServiceProviderEnabled || isQtDisplayFeatureEnabled(me, QT_SETTINGS.QT_DISPLAY_RR)) && (  
                                        <div>
                                          <span className={styles.ekgDetailsLabel}>RR:</span>
                                          {latestQTAnalysis.rr || latestQTAnalysis.rr === 0 ? Math.round(latestQTAnalysis.rr) : '***'}
                                        </div>
                                      )  
                                    }
                                  </div>
                                  <div className={classNames(styles.ekgQTDetailsCol, styles.ekgQTDetailsCol2)}>
                                    {
                                      (isServiceProviderEnabled || isQtDisplayFeatureEnabled(me, QT_SETTINGS.QT_DISPLAY_QTCF)) && (
                                        <div>
                                          <span className={styles.ekgDetailsLabel}>QTcf:</span>
                                          {latestQTAnalysis.qtcf || latestQTAnalysis.qtcf === 0 ? Math.round(latestQTAnalysis.qtcf) : '***'}
                                        </div>
                                      ) 
                                    }
                                    {
                                      (isServiceProviderEnabled || isQtDisplayFeatureEnabled(me, QT_SETTINGS.QT_DISPLAY_QTCB)) && (
                                        <div>
                                          <span className={styles.ekgDetailsLabel}>QTcb:</span>
                                          {latestQTAnalysis.qtcb || latestQTAnalysis.qtcb === 0 ? Math.round(latestQTAnalysis.qtcb) : '***'}
                                       </div>
                                      )
                                    }
                                  </div>
                                </div>
                              }


                              {qtAnalysis && qtAnalysis.qt && latestQTAnalysis.errorType &&
                                <div className={styles.ekgQTDetailsRow}>
                                  <span className={styles.ekgDetailsLabelError}>Error Note:</span>
                                  {getErrorNote(latestQTAnalysis.errorType)}
                                </div>
                              }
                            </React.Fragment>
                          }
                        </div>
                      ) : (
                        <div className={styles.ekgQTDetails}>
                          {recording && !recording.is6l && isQTEnabled && (
                            <React.Fragment>
                              <div className={styles.ekgQTDetailsRow}>
                                <h4 className={styles.ekgQTStatus}>
                                  <span className={styles.qtStatusLabel}>QT Analysis: </span>
                                </h4>
                              </div>
                              <div>
                                Only available for 6L recordings.
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      )}
                    </div>
                    <div className={styles.recordingContent}>
                      <div
                        className={styles.recordingInfo}
                      >
                        <span>25 mm/s</span>
                        <span>10 mm/mV</span>
                        {!ekgSamples.isFetching && recording && !recording.is6l &&
                          <span>
                            {/* Add on click invert, and styles */}
                            <a onClick={toggleRecordingInvert}>
                              Invert ECG
                            </a>
                          </span>
                        }
                      </div>
                      {!ekgSamples.isFetching && recording &&
                        <EkgRecording
                          height={ekgHeight}
                          width={ekgWidth}
                          recording={recording}
                          rowSeconds={rowSeconds}
                          calpulse={calpulse}
                          inverted={invertRecording}
                          is6l={recording.is6l}
                        />
                      }
                      {!ekgRelated.isFetching && relatedRecording && !isServiceProviderEnabled &&
                        <div
                          ref={node => { this.compareToPreviousEkg = node }}
                          className={styles.popoverWrapper}
                        >
                          {selectedDropover === DROPOVER_TYPES.COMPARE_TO_RELATED_RECORDING &&
                            <div className={styles.compareToPreviousEkgPopover} >
                              <div className={styles.popoverContent}>
                                <CompareEKG
                                  recording={relatedRecording}
                                  closePopover={handleOnPopoverOutsideClick}
                                  me={me}
                                />
                              </div>
                            </div>
                          }
                          <button
                            className={styles.compareToPreviousEkg}
                            onClick={() => handleOnPopoverButtonClick(DROPOVER_TYPES.COMPARE_TO_RELATED_RECORDING)}
                          >
                            Compare to Previous ECG
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                )}
              </div>
              {recording !== null && recording && !recording.isIDTF && (
                <div
                  className={styles.sidebar}
                  style={{
                    width: `${RIGHT_SIDEBAR_WIDTH + extraWidth}px`,
                    height: `${contentHeight}px`,
                  }}
                >
                  {isAddInterpretationScreenVisible
                    ? (
                      <React.Fragment>
                        <div className={isServiceProviderEnabled ? styles.isServiceProviderClass : {}}>
                          <AddInterpretationPane
                            interpretations={interpretations}
                            interpretationMap={(interpretations.data && interpretations.data.byId) || {}}
                            selectedInterpretations={selectedInterpretations}
                            handleUpdateInterpretations={updateInterpretations}
                            handleUpdateInterpretationNotes={updateInterpretationNotes}
                            memberInterpretationsDate={recording && (recording.memberInterpretations && recording.memberInterpretations.length > 0 ? recording.memberInterpretations[0].createdAt : recording.recordedAt)}
                            memberInterpretations={recording && (recording.memberInterpretations && recording.memberInterpretations.length > 0 ? recording.memberInterpretations[0] : undefined)}
                            recording={recording}
                            me={me}
                          />
                          {isMedantaAPIEnabled &&
                            <MedantaAdhocInterpretation
                              selectedMedantaInterpretations={selectedMedantaInterpretations}
                              updateMedantaInterpretations={updateMedantaInterpretations}
                              medantaInterpretations={medantaConfig.quickInterpretations}
                              vendorInterpretation={vendorInterpretation}
                              medantaInterpretationForm={medantaInterpretationForm}
                            />
                          }
                          {isServiceProviderEnabled && isServiceInterpretationFeatureEnabled && recording && !isEkgAnalyzed &&
                            <QtValuesForm
                              onSubmit={handleQtFormSubmit}
                              isSubmitting={qtPostValues.isFetching}
                              qtFormData={qtFormData}
                              isServiceProviderErrorFeatureEnabled={isServiceProviderErrorFeatureEnabled}
                              me={me}
                              isServiceProviderEnabled={isServiceProviderEnabled}
                              isServiceInterpretationFeatureEnabled={isServiceInterpretationFeatureEnabled}
                            />
                          }
                          <AddInterpretationControls
                            // if medanta true, any interpritation selection should enable submit
                            // saveDisabled={true ? (selectedInterpretations.length === 0 && !Object.keys(selectedMedantaInterpretations).length) : selectedInterpretations.length === 0}
                            // saveDisabled={selectedInterpretations.length === 0}
                            saveDisabled={isSaveDisabledCheck(selectedInterpretations, isServiceProviderEnabled, qtFormData)}
                            handleOnAddInterpretationsCancelClick={cancelAddInterpretations}
                            handleOnAddInterpretationsSaveClick={saveAddInterpretations}
                            isSubmitting={ekg.isFetching || ekgSamples.isFetching || ekgs.isFetching}
                            isMedantaAPIEnabled={isMedantaAPIEnabled}

                          />
                        </div>
                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        <NotesAndHistoryPane
                          recording={recording}
                          fetchingRecording={ekg.isFetching}
                          interpretations={interpretations}
                          interpretationMap={(interpretations.data && interpretations.data.byId) || {}}
                          isInterpretationHistoryExpanded={isInterpretationHistoryExpanded}
                          toggleInterpretationHistoryExpanded={toggleInterpretationHistoryExpanded}
                          handleOnShowAddInterpretationScreenClick={showAddInterpretationScreen}
                          showInterpretations={!isServiceProviderEnabled || 1} // enabling the condition for showing the interpretation for the service provider
                          me={me}
                          isServiceProviderEnabled={isServiceProviderEnabled}
                          qtAnalysisData={this.props[EKG_RECORDING_REDUCERS.EKG_QT]}
                          isQTEnabled={isQTEnabled}
                          isServiceInterpretationFeatureEnabled={isServiceInterpretationFeatureEnabled}
                        />
                        { // if qtAnalysis data is available, calculationType is not none & the feature is not hidden (KPA feature), rendering the team details text
                          (latestQTAnalysis  && latestQTAnalysis.calculationType !== 'none' && !isHideOverreadProviderInfoEnabled) && (
                           <div className={styles.teamDetails}>
                             { generateOverreadProviderInfo(latestQTAnalysis, isGeneralizeOverreadProviderInfoEnabled)}
                           </div>
                          )
                        }
                        {!isEkgRecordingConfirmed(recording) && recording && !(isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled) &&
                          <StackControls
                            showStackRemovalControl={showStackRemovalControl}
                            confirmAndArchiveDisabled={checkConfirmButton(recording)}
                            // confirmAndArchiveDisabled={!ekgRecordingHasInterpretations(recording)}
                            selectedDropover={selectedDropover}
                            physicianName={physicianName}
                            reassignedInbox={reassignedInbox}
                            currentInboxId={recording.stackID}
                            inboxOptions={inboxOptions}
                            inboxIsFetching={physicians.isFetching}
                            updateReassignInboxId={updateReassignInboxId}
                            handleOnButtonClick={handleOnPopoverButtonClick}
                            handleOnCancelDialogClick={handleOnStackControlsCancelDialogClick}
                            handleOnSuccessDialogClick={handleOnStackControlsSuccessDialogClick}
                            removeFromStackCallback={actionType => handleStackControl(removeFromStackCallback(actionType, currentInboxId, selectedRecordingId, recordingIds))}
                            confirmAndArchiveCallback={actionType => handleStackControl(confirmAndArchiveCallback(actionType, currentInboxId, selectedRecordingId, recordingIds))}
                            reassignCallback={actionType => handleStackControl(reassignCallback(actionType, currentInboxId, selectedRecordingId, recordingIds))}
                            me={me}
                            isServiceProviderEnabled={isServiceProviderEnabled}
                          />
                        }
                        {/* enable the qt form on the basis of isServiceProviderEnabled and isServiceInterpretationFeatureEnabled  */}
                        {isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled && recording && !isEkgAnalyzed &&
                          <QtValuesForm
                            onSubmit={handleQtFormSubmit}
                            isSubmitting={qtPostValues.isFetching}
                            qtFormData={qtFormData}
                            isServiceProviderErrorFeatureEnabled={isServiceProviderErrorFeatureEnabled}
                            me={me}
                            isServiceProviderEnabled={isServiceProviderEnabled}
                            isServiceInterpretationFeatureEnabled={isServiceInterpretationFeatureEnabled}
                          />
                        }
                      </React.Fragment>
                    )
                  }
                </div>
              )}
              {recording !== null && recording && recording.isIDTF && (
                <div
                  className={styles.sidebar}
                  style={{
                    width: `${RIGHT_SIDEBAR_WIDTH + extraWidth}px`,
                    height: `${contentHeight}px`,
                  }}
                >
                  <React.Fragment>
                    <IDTFRecordingReviewPane
                      match={match}
                      selectedRecordingId={selectedRecordingId}
                      patientId={patient.id}
                      templateId={patient.connectionTemplateID}
                    />
                  </React.Fragment>
                </div>
              )}
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height: contentHeight,
              }}
            >
              <EcgLoader />
            </div>
          )
        }
      </div>
    )
  }
}

export default EkgRecordingReviewScreen



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/EkgRecordingReviewScreen.jsx